import Immutable from 'immutable';
import {
  HOME_PATH,
  SUPPLIER_PATH,
  FOOD_UNIT_PATH,
  ITINERARY_SUPPLIER_FOOD_PATH,
  ITINERARY_SUPPLIER_FOOD_REPORT_PATH,
  ITINERARY_FOOD_INVOICE_PATH,
} from '../../../config/paths';

const INITIAL_STATE = Immutable.Map({
  cards: [
    {
      id: 'suppliers',
      title: 'Proveedores',
      path: SUPPLIER_PATH,
      icon: 'truck',
    },
    {
      id: 'itinerary-supplier-food',
      title: 'Alimentación por Itinerario',
      path: ITINERARY_SUPPLIER_FOOD_PATH,
      icon: 'calendar',
    },
    {
      id: 'itinerary-supplier-food-report',
      title: 'Reporte de Alimentación por Itinerario',
      path: ITINERARY_SUPPLIER_FOOD_REPORT_PATH,
      icon: 'file-text',
    },
    {
      id: 'itinerary-food-invoice',
      title: 'Factura de Alimentación por Itinerario',
      path: ITINERARY_FOOD_INVOICE_PATH,
      icon: 'book',
    },
  ],
  breadcrumbs: [
    {
      text: 'Inicio',
      tag: 'a',
      href: HOME_PATH,
    },
    {
      text: 'Alimentación',
      tag: 'span',
      href: FOOD_UNIT_PATH,
    },
  ],
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
